var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-empty flex-column flex-center",style:({'height': _vm.height})},[_c('div',{staticClass:"sub-empty-icon"},[_c('img',{attrs:{"src":_vm.config.icon}})]),_c('div',{staticClass:"sub-empty-message"},[_vm._v(_vm._s(_vm.config.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }